<template>
    <toolbar-option>
        <template slot="primary">
            <calendar-facet-bar-color
                :value="bar.class"
                @input="onColorInput"
            />
        </template>
        <template slot="secondary">
            <div class="f-flex f-mt-0.25 f-ml-1">
                <toggle
                    :value="bar.show"
                    :messages="messages"
                    @input="onInput"
                />
            </div>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'calendar-facet-bar';

export default {
    name: 'calendar-facet-bar',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Show a Bar under date',
            message: '',
            value: '',
            checked: true,
            messages: {
                checked: 'Yes',
                unchecked: 'No',
            },
            bar: {
                class: '',
                show: false,
            },
        };
    },

    methods: {
        onInput(isChecked) {
            if (isChecked) {
                this.bar.show = true;
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.bar);
                this.selectedElements[0].showBars = true;
            } else {
                this.bar.show = false;
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.bar);
                this.selectedElements[0].showBars = false;
            }

            this.onOptionChange(isChecked);
        },

        onColorInput(cssClass) {
            this.bar.class = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.bar);
            this.selectedElements[0].barClass = cssClass;
        },

        onSelectedElement() {
            this.bar = this.selectedElements[0].hasElementData(CUSTOM_ATTR_NAME) ? this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME) : this.bar;
        },
    },
};
</script>
